module.exports = __webpack_public_path__ + "static/media/ChevronDownIcon.ea557386.svg";